import { createFileRoute } from '@tanstack/react-router'
import { PomodoroPage } from '_/features/pomodoro/ui/pages/pomodoro-page'

export const Route = createFileRoute('/_authenticated/pomodoro')({
	staticData: { title: 'pomodoro_title' },
	component: PomodoroPage,
})
